import { render, staticRenderFns } from "./NewBookingPaymentModal.vue?vue&type=template&id=60a421e2&scoped=true"
import script from "./NewBookingPaymentModal.vue?vue&type=script&lang=js"
export * from "./NewBookingPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./NewBookingPaymentModal.vue?vue&type=style&index=0&id=60a421e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a421e2",
  null
  
)

export default component.exports